import React from 'react'
import { IconButton, Typography, Stack } from '@mui/material'
import { useCopyToClipboard } from 'src/Elements/CopyToClipboard/hook/use-copy-to-clipboard'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J2Copy } from '@e3dc-react/icons'
import { getPartnerNumberWithSpaces } from 'src/Libs/service-dashboard/functions'

interface Props {
  partnerNumber: number
}

/**
 * Display partner number and allows user to copy the number to clipboard
 */
const PartnerNumber: React.FC<Props> = ({ partnerNumber }) => {
  const { t } = useCustomTranslation()
  const { copyToClipboard } = useCopyToClipboard()

  const handleCopyToClipboard = async (): Promise<void> => {
    const value = partnerNumber ? partnerNumber.toString() : ''
    copyToClipboard(value)
  }
  return (
    <Stack mt={2} direction="row" alignItems="center" gap={1}>
      <Typography variant={'body2'}>
        {t('common.partner-number')} : {getPartnerNumberWithSpaces(partnerNumber)}
      </Typography>

      <IconButton onClick={handleCopyToClipboard}>
        <J2Copy sx={{ color: 'primary.main' }} />
      </IconButton>
    </Stack>
  )
}

export default PartnerNumber
